import { I18n } from '@calendly/i18n';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeBillingMaintenanceBanner } from '../billing_maintenance_banner_slice';
import { isVisibleSelector } from '../selectors';
const CloseButton = forwardRef((props, ref) => {
  const size = 'small';
  return <IconButton ref={ref} {...props} size={size}>
      <CloseIcon />
    </IconButton>;
});
const messageIsPhoneCss = "m59625n";
const messageCss = "mfs6suv";
const Message = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(messageCss, {
    [messageIsPhoneCss]: isPhone
  }, props.className)} />;
});
const titleIsPhoneCss = "t1mi7ezz";
const titleCss = "tgeuqi6";
const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(titleCss, {
    [titleIsPhoneCss]: isPhone
  }, props.className)} />;
});
const bannerIsPhoneCss = "byi321k";
const bannerCss = "b1iya3ca";
const Banner = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <FixedContainer ref={ref} {...props} className={classNames(bannerCss, {
    [bannerIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const BillingMaintenanceBanner = () => {
  const dispatch = useDispatch();
  const title = I18n.t('publisher.billing.stages.undergoing_maintenance.title');
  const message = I18n.t('publisher.billing.stages.undergoing_maintenance.message');
  const isVisible = useSelector(isVisibleSelector);
  if (!isVisible) return null;
  return <Banner data-component="dismissable-billing-maintenance-banner">
      <div>
        <Title>{title}</Title>
        <Message>{message}</Message>
      </div>
      <CloseButton onClick={() => dispatch(closeBillingMaintenanceBanner())} aria-label={I18n.t('publisher.action.close')} />
    </Banner>;
};

require("./billing_maintenance_banner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./billing_maintenance_banner.js");